// @ts-nocheck
/* eslint-disable */

import React, { useState, useEffect } from 'react'
import { Dialog, DialogContent, DialogActions, DialogTitle, IconButton, Card, CardContent, Typography, Alert, AlertTitle, List, ListItem, ListItemText, Button, Box, Divider, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CloseIcon from '@mui/icons-material/Close';


const InfoExceptionRule = ({ open, setOpen, selectedRow, rows, setSelectedRow }) => {

    const { t } = useTranslation()

    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [not_planning, setNotPlanning] = useState(false)
    const [long_interval, setLongInterval] = useState('')
    const [shortened_shift, setShortenedShift] = useState('')
    const [in_punch_very_early, setInPunchVeryEarly] = useState('')
    const [in_punch_early, setInPunchEarly] = useState('')
    const [in_punch_late, setInPunchLate] = useState('')
    const [out_punch_early, setOutPunchEarly] = useState('')
    const [out_punch_late, setOutPunchLate] = useState('')
    const [out_punch_very_late, setOutPunchVeryLate] = useState('')
    const [InselectedPaycodes, setInSelectedPaycodes] = useState([])
    const [OutselectedPaycodes, setOutSelectedPaycodes] = useState([])
    const [loadingInfo, setLoadingInfo] = useState(true)

    useEffect(() => {
        if (open && selectedRow.length > 0) {
            const row = rows.find(row => row.id === selectedRow[0])
            setName(row?.name)
            setDescription(row.description)
            setNotPlanning(row.no_planning)
            setLongInterval(row.long_interval)
            setShortenedShift(row.shortened_shift)
            setInPunchVeryEarly(row.punch_in[0])
            setInPunchEarly(row.punch_in[1])
            setInPunchLate(row.punch_in[2])
            setOutPunchEarly(row.punch_out[0])
            setOutPunchLate(row.punch_out[1])
            setOutPunchVeryLate(row.punch_out[2])
            setOutSelectedPaycodes(row.out_paycode ? row.out_paycode : [])
            setInSelectedPaycodes(row.in_paycode ? row.in_paycode : [])
            setLoadingInfo(false)
        }
    }

        , [open, selectedRow, rows])


    const close = () => {
        setOpen(false)
        setLoadingInfo(false)
        setName()
        setDescription('')
        setNotPlanning(false)
        setLongInterval('')
        setShortenedShift('')
        setInPunchVeryEarly('')
        setInPunchEarly('')
        setInPunchLate('')
        setOutPunchEarly('')
        setOutPunchLate('')
        setOutPunchVeryLate('')
        setOutSelectedPaycodes([])
        setInSelectedPaycodes([])
        setSelectedRow([])
    }

    return (
        <>
            {JSON.parse(localStorage.getItem("permissions")).filter(permission => ['timekeeper.GetPaycodes'].includes(permission)).length !== 1 &&
                <Alert severity="warning">
                    <AlertTitle>{t('general.alerts.missing_permission.title')}</AlertTitle>

                    <List dense>
                        {JSON.parse(localStorage.getItem("permissions")).find(permission => permission === 'timekeeper.GetPaycodes') === undefined &&
                            <ListItem>
                                <ListItemText
                                    primary={'timekeeper.GetPaycodes'}
                                />
                            </ListItem>
                        }
                    </List>
                </Alert>
            }
            <Dialog
                maxWidth="sm"
                fullWidth
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{t('settings.exception_rules.table.dialog.info.title')}</DialogTitle>

                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers sx={{ p: 3 }}>
                    <CardContent sx={{ border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: 3, p: 2 }}>
                        <Box sx={{ width: '100%', display: 'grid', gridGap: 1, gap: 1, mt: 1 }}>
                            <Card>
                                <CardContent sx={{ height: '100%' }}>
                                    <Typography variant="body1">
                                        <Typography component="span" color="primary">{t('settings.exception_rules.table.dialog.info.name')}:</Typography>{' '}{name}
                                    </Typography>
                                    <Typography variant="body1">
                                        <Typography component="span" color="primary">{t('settings.exception_rules.table.dialog.info.not_planning')}:</Typography>{' '}{not_planning === true ? "Si" : "No"}
                                    </Typography>
                                    <Typography variant="body1">
                                        <Typography component="span" color="primary">{t('settings.exception_rules.table.dialog.info.long_interval')}:</Typography>{' '}{long_interval}
                                    </Typography>
                                    <Typography variant="body1">
                                        <Typography component="span" color="primary">{t('settings.exception_rules.table.dialog.info.shortened_shift')}:</Typography>{' '}{shortened_shift}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Divider sx={{ my: 1.5 }} />
                        <Typography variant='h6'>{t('settings.exception_rules.table.dialog.info.punch_in')}</Typography>
                        <Box sx={{ width: '100%', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gridGap: 3, gap: 3, mt: 1 }}>
                            <Card>
                                <CardContent sx={{ height: '100%', alignItems: 'center', justifyItems: 'center' }}>
                                    <Typography variant='body1' color="primary">{t('settings.exception_rules.table.dialog.info.in_punch_very_early')}</Typography>
                                    <Typography variant='body1'>{in_punch_very_early}</Typography>
                                </CardContent>
                            </Card>
                            <Card>
                                <CardContent sx={{ height: '100%', alignItems: 'center', justifyItems: 'center' }}>
                                    <Typography variant='body1' color="primary">{t('settings.exception_rules.table.dialog.info.in_punch_early')}</Typography>
                                    <Typography variant='body1'>{in_punch_early}</Typography>
                                </CardContent>
                            </Card>
                            <Card>
                                <CardContent sx={{ height: '100%', alignItems: 'center', justifyItems: 'center' }}>
                                    <Typography variant="body1" color="primary">{t('settings.exception_rules.table.dialog.info.in_punch_late')}</Typography>
                                    <Typography variant="body1">{in_punch_late}</Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Box sx={{ width: '100%', display: 'grid', gridGap: 1, gap: 1, mt: 1 }}>
                            <Card>
                                <CardContent sx={{ height: '100%' }}>
                                    <Typography variant='body1' color="text.secondary">{t('settings.exception_rules.table.dialog.info.in_paycodes_duration')}</Typography>
                                    <Typography variant='body1'>
                                        <Typography component="span" color="primary">{'nombre:'}</Typography>{' '}{InselectedPaycodes ? InselectedPaycodes.name : ''}
                                    </Typography>
                                    <Typography variant='body1' color="text.secondary">
                                        <Typography component="span" color="primary">{'tipo:'}</Typography>{' '}{InselectedPaycodes ? InselectedPaycodes.type : ''}
                                    </Typography>
                                    <Typography variant="body1">
                                        <Typography component="span" color="primary">{'unit:'}</Typography>{' '}{InselectedPaycodes ? InselectedPaycodes.unit : ''}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Divider sx={{ my: 1.5 }} />
                        <Typography variant='h6'>{t('settings.exception_rules.table.dialog.info.punch_out')}</Typography>
                        <Box sx={{ width: '100%', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gridGap: 3, gap: 3, mt: 1 }}>
                            <Card>
                                <CardContent sx={{ height: '100%', alignItems: 'center', justifyItems: 'center' }}>
                                    <Typography variant="body1" color="primary">{t('settings.exception_rules.table.dialog.info.out_punch_early')}</Typography>
                                    <Typography variant="body1">{out_punch_early}</Typography>
                                </CardContent>
                            </Card>
                            <Card>
                                <CardContent sx={{ height: '100%', alignItems: 'center', justifyItems: 'center' }}>
                                    <Typography variant="body1" color="primary">{t('settings.exception_rules.table.dialog.info.out_punch_late')}</Typography>
                                    <Typography variant="body1">{out_punch_late}</Typography>
                                </CardContent>
                            </Card>
                            <Card>
                                <CardContent sx={{ height: '100%', alignItems: 'center', justifyItems: 'center' }}>
                                    <Typography variant="body1" color="primary">{t('settings.exception_rules.table.dialog.info.out_punch_very_late')}</Typography>
                                    <Typography variant="body1">{out_punch_very_late}</Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Box sx={{ width: '100%', display: 'grid', gridGap: 1, gap: 1, mt: 1 }}>
                            <Card>
                                <CardContent sx={{ height: '100%' }}>
                                    <Typography variant='body1' color="text.secondary">{t('settings.exception_rules.table.dialog.info.out_paycodes_duration')}</Typography>
                                    <Typography variant="body1">
                                        <Typography component="span" color='primary'>{'nombre:'}</Typography>{OutselectedPaycodes ? OutselectedPaycodes.name : ''}
                                    </Typography>
                                    <Typography variant='body1' color="text.secondary">
                                        <Typography component="span" color='primary'>{'tipo:'}</Typography>{OutselectedPaycodes ? OutselectedPaycodes.type : ''}
                                    </Typography>
                                    <Typography variant="body1">
                                        <Typography component="span" color='primary'>{'unit:'}</Typography>{OutselectedPaycodes ? OutselectedPaycodes.unit : ''}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Box>
                        <Divider sx={{ my: 1.5 }} />
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }} sx={{ mt: 1 }}>
                            <Typography variant="body1">
                                <Typography component="span">{t('settings.exception_rules.table.dialog.info.description')}:</Typography>{' '}{description}
                            </Typography>
                        </Grid>
                    </CardContent>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={() => close()} loading={loadingInfo}>
                        {t('general.buttons.close')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>

    )
}

export { InfoExceptionRule }